module.exports = __webpack_public_path__ + "img/instagram.19e14ea.svg";